import MenuItem from './MenuItem';

interface MenuItemData {
  id: number;
  name: string;
  description: string;
  price: number;
  image: string;
  alt: string;
  category: string;
  dietary: string[];
  spiceLevel: string;
  prepTime: number;
  isPopular: boolean;
  calories: number;
  protein: number;
  allergens: string[];
  ingredients: string[];
}

interface MenuGridProps {
  items: MenuItemData[];
  onCustomize: (item: MenuItemData) => void;
}

const MenuGrid = ({ items, onCustomize }: MenuGridProps) => {
  if (items.length === 0) {
    return (
      <div data-component-id="src/app/menu-experience/components/MenuGrid.tsx:29:6" data-component-path="src/app/menu-experience/components/MenuGrid.tsx" data-component-line="29" data-component-file="MenuGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20py-16%22%7D" className="text-center py-16">
        <div data-component-id="src/app/menu-experience/components/MenuGrid.tsx:30:8" data-component-path="src/app/menu-experience/components/MenuGrid.tsx" data-component-line="30" data-component-file="MenuGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-6xl%20mb-4%22%2C%22textContent%22%3A%22%F0%9F%94%8D%22%7D" className="text-6xl mb-4">🔍</div>
        <h3 data-component-id="src/app/menu-experience/components/MenuGrid.tsx:31:8" data-component-path="src/app/menu-experience/components/MenuGrid.tsx" data-component-line="31" data-component-file="MenuGrid.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-2xl%20font-bold%20font-display%20text-textPrimary%20mb-2%22%2C%22textContent%22%3A%22No%20items%20found%22%7D" className="text-2xl font-bold font-display text-textPrimary mb-2">No items found</h3>
        <p data-component-id="src/app/menu-experience/components/MenuGrid.tsx:32:8" data-component-path="src/app/menu-experience/components/MenuGrid.tsx" data-component-line="32" data-component-file="MenuGrid.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-textSecondary%22%2C%22textContent%22%3A%22Try%20adjusting%20your%20filters%20or%20search%20query%22%7D" className="text-textSecondary">Try adjusting your filters or search query</p>
      </div>
    );
  }

  return (
    <div data-component-id="src/app/menu-experience/components/MenuGrid.tsx:38:4" data-component-path="src/app/menu-experience/components/MenuGrid.tsx" data-component-line="38" data-component-file="MenuGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20sm%3Agrid-cols-2%20lg%3Agrid-cols-3%20gap-6%22%7D" className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {items.map((item) => (
        <MenuItem data-component-id="src/app/menu-experience/components/MenuGrid.tsx:40:8" data-component-path="src/app/menu-experience/components/MenuGrid.tsx" data-component-line="40" data-component-file="MenuGrid.tsx" data-component-name="MenuItem" data-component-content="%7B%22elementName%22%3A%22MenuItem%22%7D" key={item.id} item={item} onCustomize={onCustomize} />
      ))}
    </div>
  );
};

export default MenuGrid;